import React, { useState } from 'react';
import { SearchIcon, GlobeIcon, UserIcon, ChevronDownIcon, MenuIcon, BellIcon } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { UserRole } from '../../data/types';
export function Header() {
  const {
    state,
    dispatch,
    navigate
  } = useApp();
  const {
    currentRole,
    language,
    searchQuery,
    notifications
  } = state;
  const [showRoleDropdown, setShowRoleDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const roles: UserRole[] = ['Admin', 'Legal Officer', 'Viewer'];
  const unreadCount = notifications.filter(n => !n.read).length;
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      dispatch({
        type: 'SET_FILTERS',
        payload: {
          searchQuery
        }
      });
      navigate('land-records');
    }
  };
  const roleColors: Record<UserRole, string> = {
    Admin: 'bg-purple-100 text-purple-700',
    'Legal Officer': 'bg-blue-100 text-blue-700',
    Viewer: 'bg-gray-100 text-gray-700'
  };
  return <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 lg:px-6" data-id="element-20">
      {/* Mobile Menu Button */}
      <button className="md:hidden p-2 text-gray-600 hover:text-gray-900" onClick={() => setShowMobileMenu(!showMobileMenu)} data-id="element-21">
        <MenuIcon className="w-6 h-6" data-id="element-22" />
      </button>

      {/* Search */}
      <form onSubmit={handleSearch} className="flex-1 max-w-xl mx-4" data-id="element-23">
        <div className="relative" data-id="element-24">
          <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-25" />
          <input type="text" placeholder={language === 'en' ? 'Search by Land ID, Deed No, Khatian, Dag...' : 'ভূমি আইডি, দলিল নং, খতিয়ান, দাগ দিয়ে খুঁজুন...'} value={searchQuery} onChange={e => dispatch({
          type: 'SET_SEARCH_QUERY',
          payload: e.target.value
        })} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-26" />
        </div>
      </form>

      {/* Right Section */}
      <div className="flex items-center gap-2 lg:gap-4" data-id="element-27">
        {/* Notifications */}
        <button onClick={() => navigate('notifications')} className="relative p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg" data-id="element-28">
          <BellIcon className="w-5 h-5" data-id="element-29" />
          {unreadCount > 0 && <span className="absolute top-1 right-1 w-4 h-4 bg-red-500 rounded-full text-[10px] text-white flex items-center justify-center" data-id="element-30">
              {unreadCount}
            </span>}
        </button>

        {/* Language Switcher */}
        <button onClick={() => dispatch({
        type: 'SET_LANGUAGE',
        payload: language === 'en' ? 'bn' : 'en'
      })} className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-31">
          <GlobeIcon className="w-4 h-4" data-id="element-32" />
          <span className="hidden sm:inline font-medium" data-id="element-33">
            {language === 'en' ? 'EN' : 'বাংলা'}
          </span>
        </button>

        {/* Role Selector */}
        <div className="relative" data-id="element-34">
          <button onClick={() => setShowRoleDropdown(!showRoleDropdown)} className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${roleColors[currentRole]}`} data-id="element-35">
            <UserIcon className="w-4 h-4" data-id="element-36" />
            <span className="hidden sm:inline" data-id="element-37">{currentRole}</span>
            <ChevronDownIcon className="w-4 h-4" data-id="element-38" />
          </button>

          {showRoleDropdown && <>
              <div className="fixed inset-0 z-10" onClick={() => setShowRoleDropdown(false)} data-id="element-39" />
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20" data-id="element-40">
                <div className="px-3 py-2 text-xs text-gray-500 uppercase tracking-wider border-b border-gray-100" data-id="element-41">
                  Switch Role (Demo)
                </div>
                {roles.map(role => <button key={role} onClick={() => {
              dispatch({
                type: 'SET_ROLE',
                payload: role
              });
              setShowRoleDropdown(false);
            }} className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-50 flex items-center justify-between ${currentRole === role ? 'bg-gray-50' : ''}`} data-id="element-42">
                    <span data-id="element-43">{role}</span>
                    {currentRole === role && <span className="text-blue-600" data-id="element-44">✓</span>}
                  </button>)}
              </div>
            </>}
        </div>
      </div>
    </header>;
}